import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { TransformCta } from '../TransformCta';
import { faqs } from '../../data/faqs';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-ink py-16 sm:py-24" aria-labelledby="faq-title" data-id="element-148" data-mp="122vd2h2vwvq0">
      <div className="mx-auto max-w-3xl px-5" data-id="element-149" data-mp="1ptip9eju27id">
        <SectionHeading title={<span id="faq-title" data-id="element-151" data-mp="1urtwrimno5xf">Frequently asked questions</span>} data-id="element-150" data-mp="1urarb1e6za0a" />

        <ul className="mt-10 space-y-3" data-id="element-152" data-mp="1ut52hnznvnr6">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl border border-line bg-panel" data-id="element-153" data-mp="1l0pk4pkgcx5r" data-mpi={i}>
                <h3 data-id="element-154" data-mp="28qtmyuptgsvp">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-[17px] font-semibold text-white transition-colors duration-150 hover:bg-panel2" data-id="element-155" data-mp="28qa49bsce0gm">
                    {f.q}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-volt transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-156" data-mp="2yhv66re16qi5" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-157" data-mp="32hdorgidqpht">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-158" data-mp="3hdl9qj1m3uy5">
                      <p className="px-5 pb-5 text-[16px] leading-relaxed text-mist" data-id="element-159" data-mp="27pxod8tudltx">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <TransformCta label="All clear — I’m in for $27" data-id="element-160" data-mp="2gpkntp30ghkc" />
      </div>
    </section>;
}